import { useUsers } from 'hooks/useUsers.hooks'
import UsersDataGrid from '../view-users/UsersDataGrid'
import { Button, Grid } from '@mui/material'
import { Link } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';


const AdminArchivedDonorScreen = function() {
  const usersState = useUsers('Food Donor', false)
  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
      <Button variant="contained" component={Link} to='/donors'>
          Return to Active Donors
      </Button>
      </Grid>
      
      <Grid item xs={12}>
      <MainCard title="Archived Donors">
      {!usersState.ready ? (
        <div>Loading</div>
      ) : (
        <UsersDataGrid
          role="Food Donor"
          active={false}
        />
      )}
      </MainCard>
      </Grid>
    </Grid>
  )
}

export default AdminArchivedDonorScreen
